import { Component, Input, Output } from '@angular/core';
import { BaseComponent } from '../base-components/base-component.component';
import { Subject } from 'rxjs';
import { ValidationHandlerService } from '../../services/validation-handler.service';
import { LanguageService } from '../../services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-edit-view',
    template: `
        <div class="d-flex flex-row gap-1">
            <button class="d-flex gap-2 align-items-center action-button" (click)="onEditItem()">
                <img class="icon" src="assets/icon/edit.png" />
            </button>
            <button class="d-flex gap-2 align-items-center action-button" (click)="onViewItem()">
                <img class="icon" src="assets/icon/search.png" />
            </button>
        </div>
    `,
    styles: [
        `
            .icon {
                width: 24px;
                height: 24px;
                cursor: pointer;
            }
        `,
    ],
})
export class EditViewComponent extends BaseComponent {
    constructor(protected override modalService: BsModalService, private router: Router, protected override spinnerService: NgxSpinnerService, protected translateService: TranslateService, protected override languageService: LanguageService, protected override validationHandlerService: ValidationHandlerService) {
        super(spinnerService, modalService, validationHandlerService, translateService, languageService);
    }

    @Output()
    emitter = new Subject<{ action: string; data: any }>();

    @Input()
    data: any = {};

    @Input() isCandidateTable: boolean = false;

    ngOnInit() {}

    onEditItem() {
        this.emitter.next({
            action: 'edit',
            data: this.data,
        });
    }

    onViewItem() {
        this.emitter.next({
            action: 'view',
            data: this.data,
        });
    }
}
